import {
  CardContent,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core";
import { isThisMinute } from "date-fns";
import React, { useEffect, useRef, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import StyledTableRow from "../../components/StyledTableRow";
import {
  convertToThousands,
  getUniqueValues,
  _isNaN,
  countOrACVFormatter,
} from "../../util/customFunctions";
import * as d3 from "d3";
import { getMixKey } from "../../util/generateHeadings";
import {
  customSortedOppType,
  customSortedSegments,
} from "../../util/customSortings";
import { deSnake } from "../../util/dataFormatter";
import { color } from "d3";
import CopyTablesObject from "../../components/xlsx-export/CopyTablesObject";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import CustomWidthTooltip from "../../components/Buttons/Expand_Collapse_Tooltip";

const useStyle = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    width: "100%",
    padding: "1rem",
  },
  acvColumn:{
    width: 80,
    textAlign: "right",
    maxWidth: 150,
  },
  sticky: {
    position: "sticky",
    left: -1,
    background: "white",
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      right: 0,
      width: "1.5px",
      background: "lightgrey",
    },
  },
  stickyHeader: {
    position: "sticky",
    top: -1,
    background: "white",
    outline: "lightgrey solid 1px",
    outlineOffset: "-1.5px",
    zIndex: 5,
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      right: 0,
      width: "0.5px",
    },
  },
  content: { 
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "1rem",
  },
  table: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
  },
  repText: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "left",
    minWidth: "169px",
    fontWeight: "inherit",
  },
  repNumber: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
    fontWeight: "inherit",
  },
  repNumberACV: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
    minWidth: "92px",
    fontWeight: "inherit",
  },
  repNumberPercent: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
    minWidth: "90px",
    fontWeight: 600,
    cursor: "pointer",
  },
  repTextH: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "left",
    fontWeight: 600,
  },
  repNumberH: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
    fontWeight: 600,
  },
  tableHeader: {
    fontWeight: 600,
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    fontSize: "15px",
    whiteSpace: "normal",
    textAlign: "center",
  },
  repHeader: {
    fontWeight: 600,
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    width: "200px",
  },
  inner: {
    height: 375,
    minWidth: 500,
  },
  chart: {
    height: "100%",
  },
  tableCell: {
    whiteSpace: "normal",
  },
  indentName: {
    paddingLeft: 30,
  },
  blackLabel: {
    color: "black",
  },
  inputFieldContainers: {
    marginBottom: 10,
    padding: 10,
    [theme.breakpoints.up("lg")]: {
      paddingRight: 0,
    },
  },
  fontBold: {
    fontWeight: 600,
  },
  stickyColumn: {
    minWidth: 200,
    left: 0,
    position: "sticky",
    zIndex: theme.zIndex.appBar + 1,
  },
  centeredTableContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  exportButtonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    marginBottom: "0.6rem",
  },
}));

export default function DealRegistrationTable(props) {
  console.log(props, 'PROPS DATA');
  const classes = useStyle();
  const tableRef = React.createRef();
  const tableContainerRef = useRef();

  const [isOverflowing, setIsOverflowing] = useState(false);
  const [rowPin, setrowPin] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  const [isSticky, setIsSticky] = useState(false);
  const [parentWidth, setparentWidth] = useState();
  const [isRegion, setIsRegion] = useState(true);

  const HtmlTooltip = withStyles((theme) => ({
      tooltip: {
        backgroundColor: "rgb(255,255,255,0.8)",
        color: "black",
        fontFamily: "roboto",
        fontSize: theme.typography.pxToRem(14),
        borderRadius: "1rem",
        padding: "0px",
        boxShadow: "0 0.1rem 0.1rem 0",
        marginTop: "0.4rem",
      },
    }))(Tooltip);

  let countinc = 0;
  let globalExpand = [];

  const handleResize = () => {
    const parentWidth = tableContainerRef.current?.getBoundingClientRect().width;
    setparentWidth(parentWidth);
    console.log("Resized testParentWidth", parentWidth);
  };

  const handleExpandClick = (rowId) => {
    setExpandedRows((prevExpandedRows) => {
      const isRowExpanded = prevExpandedRows.includes(rowId);
      if (isRowExpanded) {
        return prevExpandedRows.filter((expandedRow) => expandedRow !== rowId);
      } else {
        return [...prevExpandedRows, rowId];
      }    
    });
  };

  useEffect(() => {
    setExpandedRows(globalExpand);
  }, []);

  const globalExpandData = (con) => {
    if (con === true) {
      setExpandedRows(globalExpand);
      setIsRegion(true);
    } else {
      setExpandedRows([]);
      setIsRegion(false);
    }
    handleResize();
  };

  // Fixed data structure
  const uniqueCols = ['Leads', 'Contacts', 'Total' ];
  const uniqueQuarters = props.uniqueQuarters || [];
  const quarterData = props.quarterData || [];
  const monthData = props.monthData || [];

  useEffect(() => {
    const tableContainer = document.getElementById("myTableContainer-second");

    const handleOverflowCheck = () => {
      if (tableContainer) {
        setIsOverflowing(
          tableContainer.scrollWidth > tableContainer.offsetWidth
        );
      }
    };

    handleOverflowCheck();
    window.addEventListener("resize", handleOverflowCheck);

    return () => {
      window.removeEventListener("resize", handleOverflowCheck);
    };
  }, []);

  useEffect(() => {
    const tableContainer = tableContainerRef.current;

    const handleScroll = () => {
      if (tableContainer.scrollLeft > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }

      if (tableContainer.scrollTop > 0) {
        setrowPin(true);
      } else {
        setrowPin(false);
      }
    };

    tableContainer.addEventListener("scroll", handleScroll);

    return () => {
      tableContainer.removeEventListener("scroll", handleScroll);
    };
  }, [classes.sticky]);

  useEffect(() => {
    const parentWidth = tableContainerRef.current?.getBoundingClientRect().width;
    setparentWidth(parentWidth);
  }, [parentWidth, expandedRows]);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className={classes.root}>
      <CardContent className={classes.content}>
        {parentWidth !== undefined ? (
          <div 
            className={classes.exportButtonContainer}
            style={{
              width: `${parentWidth}px`,
            }}
          >
            <CopyTablesObject tableRef={tableRef} />
          </div>
        ) : null}

        <div className={classes.centeredTableContainer}>
          <TableContainer
            className={classes.mainTable}
            id="myTableContainer-second"
            ref={tableContainerRef}
            style={{
              width: "auto",
              borderLeft: isSticky ? "0.5px solid lightgrey" : "",
              borderTop: rowPin ? "0.5px solid lightgrey" : "",
              maxHeight: "85vh",
              border: "1px solid lightgrey",
              borderRadius: "4px",
            }}
          >
            <Table
              ref={tableRef}
              size="small"
              aria-label="html table"
              style={{ tableLayout: "auto", width: "initial" }}
              data-test={
                props.dataTest
                  ? props.dataTest
                  : "quota-attainment-detail-table"
              }
            >
              <TableHead style={{ position: "sticky", top: -1, zIndex: 5 }}>
                <TableRow
                  style={{
                    fontWeight: 600,
                    paddingLeft: 5,
                    position: "sticky",
                    outline: "lightgrey solid 0.5px",
                    outlineOffset: "-1.5px",
                  }}
                >
                  {/* First column header - Quarter/Month */}
                  <TableCell
                    align="center"
                    className={
                      isSticky
                        ? `${classes.sticky} ${classes.repHeader}`
                        : classes.repHeader
                    }
                    colSpan={1}
                    style={{
                      outline: "lightgrey solid 0.5px",
                      outlineOffset: "-1.5px",
                      background: "white",
                      minWidth: "200px",
                    }}
                  >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div>
                        {"Quarter / Month"}
                      </div>
                      <div style={{ display: "flex" }}>
                        <CustomWidthTooltip
                          title={"Expand All"}
                          placement="top-start"
                        >
                          <KeyboardArrowDownIcon
                            onClick={() => globalExpandData(true)}
                            style={{ color: "gray", cursor: "pointer" }}
                          />
                        </CustomWidthTooltip>
                        <CustomWidthTooltip
                          title={"Collapse All"}
                          placement="top-start"
                        >
                          <KeyboardArrowUpIcon
                            onClick={() => globalExpandData(false)}
                            style={{ color: "gray", cursor: "pointer" }}
                          />
                        </CustomWidthTooltip>
                      </div>
                    </div>
                  </TableCell>

                  {/* Column headers - uniqueCols */}
                  {uniqueCols.map((col, index) => (
                    <TableCell
                      key={col}
                      align="center"
                      style={{
                        background: index % 2 === 0 ? "#4471c4" : "#5b9bd5",
                        color: "white",
                        width: 120,
                        maxWidth: 200,
                        minWidth: 100,
                      }}
                      className={classes.repHeader}
                      colSpan={1}
                    >
                      {col}
                    </TableCell>
                  ))}
                </TableRow>

                {/* Show "No data available" if no quarters */}
                {uniqueQuarters.length === 0 && (
                  <TableRow>
                    <TableCell
                      colSpan={uniqueCols.length + 1}
                      className={classes.repHeader}
                      style={{ width: 400, textAlign: "center" }}
                    >
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableHead>

              <TableBody>
                {uniqueQuarters.map((qtr, i) => {
                  globalExpand.push(i);
                  countinc = countinc + 1;
                  
                  // Get quarter data
                  const currentQuarterData = quarterData.filter(f => f.quarter === qtr);
                  const quarterCount = currentQuarterData.length > 0 ? currentQuarterData[0].count : 0;
                  const quarterContcactCount = currentQuarterData.length > 0 ? currentQuarterData[0].contactCount : 0;
                   const quarterTotalCount = currentQuarterData.length > 0 ? currentQuarterData[0].totalCount : 0;
                  
                  // Get months for this quarter
                  const quarterMonths = monthData
                    .filter(f => f.quarter === qtr)
                    .map(f => f.month)
                    .filter(getUniqueValues); // unique months

                  return (
                    <React.Fragment key={i}>
                      {/* Quarter Row - Blue background */}
                      <StyledTableRow style={{ background: "#dae3f3" }}>
                        <TableCell
                          align="left"
                          className={
                            isSticky
                              ? `${classes.sticky} ${classes.table} ${classes.repHeader}`
                              : `${classes.table} ${classes.repHeader}`
                          }
                          style={{
                            background: "#dae3f3",
                            minWidth: "200px",
                            cursor: "pointer",
                          }}
                          colSpan={1}
                          onClick={() => handleExpandClick(i)}
                        >
                          <div style={{ display: "flex", alignItems: "center" }}>
                            {expandedRows.includes(i) ? (
                              <KeyboardArrowUpIcon
                                style={{ color: "gray", cursor: "pointer" }}
                              />
                            ) : (
                              <KeyboardArrowDownIcon
                                style={{ color: "gray", cursor: "pointer" }}
                              />
                            )}
                            <div style={{ marginLeft: "8px" }}>{qtr}</div>
                          </div>
                        </TableCell>

                        {/* Quarter data columns - Blue background */}
                      
                          <TableCell
                            key={`${qtr}-108`}
                            align="right"
                            className={classes.repHeader}
                            style={{
                              background: "#dae3f3",
                              cursor: "pointer",
                              width: 120,
                              maxWidth: 200,
                            }}
                            onClick={() => props.handleChangeLocation && props.handleChangeLocation('drilldownOnGraph', props.isContact,  `${props.header} (Leads)`, [qtr], quarterMonths)}
                          >
                            {countOrACVFormatter(quarterCount)}
                          </TableCell>

                           <TableCell
                            key={`${qtr}-101`}
                            align="right"
                            className={classes.repHeader}
                            style={{
                              background: "#dae3f3",
                              cursor: "pointer",
                              width: 120,
                              maxWidth: 200,
                            }}
                            onClick={() => props.handleChangeLocation && props.handleChangeLocation('drilldownOnGraph', true,  `${props.header} (Contacts)`, [qtr], quarterMonths)}
                          >
                            {countOrACVFormatter(quarterContcactCount)}
                          </TableCell>

                           <TableCell
                            key={`${qtr}-100`}
                            align="right"
                            className={classes.repHeader}
                            style={{
                              background: "#dae3f3",
                              // cursor: "pointer",
                              width: 120,
                              maxWidth: 200,
                            }}
                            // onClick={() => props.handleChangeLocation && props.handleChangeLocation('drilldownOnGraph', props.isContact,  props.header, [qtr], quarterMonths)}
                          >
                            {countOrACVFormatter(quarterTotalCount)}
                          </TableCell>
                          
                      
                      </StyledTableRow>

                      {/* Month Rows (when expanded) - Alternating white/grey */}
                      {expandedRows.includes(i) &&
                        quarterMonths.map((month, monthIndex) => {
                          const currentMonthData = monthData.filter(f => f.month === month);
                          const monthCount = currentMonthData.length > 0 ? currentMonthData[0].count : 0;
                          const monthContactCount = currentMonthData.length > 0 ? currentMonthData[0].contactCount : 0;
                          const monthTotalCount = currentMonthData.length > 0 ? currentMonthData[0].totalCount : 0;
                          
                          // Determine background color - alternating white and grey
                          const isEvenMonth = monthIndex % 2 === 0;
                          const monthRowBackground = isEvenMonth ? "white" : "#f5f5f5";
                          const stickyBackground = isEvenMonth ? "white" : "#f5f5f5";

                          return (
                            <StyledTableRow key={`${i}-${monthIndex}`} style={{ background: monthRowBackground }}>
                              <TableCell
                                align="left"
                                className={
                                  isSticky
                                    ? `${classes.sticky} ${classes.table} ${classes.indentName}`
                                    : `${classes.table} ${classes.indentName}`
                                }
                                style={{
                                  paddingLeft: "40px",
                                  background: isSticky ? stickyBackground : monthRowBackground,
                                  minWidth: "200px",
                                }}
                                colSpan={1}
                              >
                                {month}
                              </TableCell>

                              {/* Month data columns - Same alternating background */}
                             
                                <TableCell
                                  key={`${month}-456`}
                                  align="right"
                                  className={classes.repNumber}
                                  style={{
                                    cursor: "pointer",
                                    width: 120,
                                    maxWidth: 200,
                                    background: monthRowBackground,
                                  }}
                                  onClick={() => props.handleChangeLocation && props.handleChangeLocation('drilldownOnGraph', props.isContact, `${props.header} (Leads)`, [qtr], [month])}
                                >
                                  {monthCount > 0 ? countOrACVFormatter(monthCount) : '-'}
                                </TableCell>

                                 <TableCell
                                  key={`${month}-123`}
                                  align="right"
                                  className={classes.repNumber}
                                  style={{
                                    cursor: "pointer",
                                    width: 120,
                                    maxWidth: 200,
                                    background: monthRowBackground,
                                  }}
                                  onClick={() => props.handleChangeLocation && props.handleChangeLocation('drilldownOnGraph', true, `${props.header} (Contacts)`, [qtr], [month])}
                                >
                                  {monthContactCount > 0 ? countOrACVFormatter(monthContactCount) : '-'}
                                </TableCell>

                                 <TableCell
                                  key={`${month}12}`}
                                  align="right"
                                  className={classes.repNumber}
                                  style={{
                                    // cursor: "pointer",
                                    width: 120,
                                    maxWidth: 200,
                                    background: monthRowBackground,
                                  }}
                                  // onClick={() => props.handleChangeLocation && props.handleChangeLocation('drilldownOnGraph', props.isContact, props.header, [qtr], [month])}
                                >
                                  {monthTotalCount > 0 ? countOrACVFormatter(monthTotalCount) : '-'}
                                </TableCell>
                           
                            </StyledTableRow>
                          );
                        })
                      }
                    </React.Fragment>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </CardContent>
    </div>
  );
}